/** ESCHER FALLS — 한국어。 */

import type { Strings } from './ja';

export const KO: Strings = {
  pour: '방수',
  lever: '레버',
  leverAria: '레버를 당기다',
  retry: '다시 시작',
  again: '한 번 더',
  next: '다음',
  share: '이 한 장 보내기',
  shareFailed: '보낼 수 없었습니다',
  rotateLeft: '시점을 왼쪽으로 돌리기',
  rotateRight: '시점을 오른쪽으로 돌리기',
  tiltUp: '시점을 올리기',
  tiltDown: '시점을 내리기',
  topDown: '위에서',
  water: (left, total) => `물 ${left} / ${total}`,
  moves: (left, total) => `수 ${left} / ${total}`,
  timeLeft: (time) => `남은 시간 ${time}`,
  drops: (n) => `물방울 ${n}`,

  resultClear: '통했다',
  resultFail: '통하지 않았다',
  clearTitle: '통수',
  fail: {
    time: '시간이 다했다',
    moves: '수가 다했다',
    drywell: '마른 우물로 흘러들었다',
    water: '물이 다했다',
    deadend: '물이 막힌 곳으로 떨어졌다',
  },
  extendByAd: '광고를 보고 30초 연장',
  extendByDrops: (cost) => `물방울 ${cost}로 30초 연장`,
  multiplyByAd: (mult) => `광고를 보고 물방울 ×${mult}`,

  stages: '스테이지',
  settingsAria: '설정',
  menuAria: '메뉴',
  back: '돌아가기',
  loop1: '1회차',
  loop2: '2회차',
  loopNote: '2회차는 수와 시간이 더 빡빡합니다. 기록은 1회차와 따로 남습니다.',
  shop: '상점',
  groupMain: '본편',
  groupExtra1: '엑스트라',
  groupExtra2: '엑스트라 2집',
  freeTrial: '체험',
  notPurchased: (n, name) => `${n} ${name}(미구매)`,
  lockedStage: '잠긴 스테이지',
  extraLockedFree: '1번 「거꾸로 흐르는 폭포」는 무료로 즐길 수 있습니다. 나머지는 설정(≡)에서 구매하면 열립니다.',
  extraLocked: '설정(≡)에서 구매하면 열립니다.',
  extra2Locked: '11번째부터는 1~10번을 모두 통수하면 열립니다.',
  extra2LockedUnowned: '설정(≡)에서 구매하고 1~10번을 모두 통수하면 11번째부터 열립니다.',
  extra2Note: '엑스트라를 모두 통수하면 열립니다.',
  progress: (cleared, total) => `본편 ${cleared} / ${total} 통수`,
  totalTime: (time) => `합계 ${time}`,
  totalNone: '합계 —',

  settings: '설정',
  bgm: '주변 소리',
  se: '효과음',
  testSound: '소리 확인',
  audioStatus: (state) => `소리 상태: ${state}`,
  audioState: {
    locked: '잠김(화면을 한 번 만지면 켜집니다)',
    running: '작동 중',
    suspended: '멈춤',
  },
  demoNote: (n) => `여기까지 ${n}개 스테이지가 체험판입니다. 전체 42개는 앱에서.`,
  demoGet: 'App Store에서 받기',
  // — 今日の一面（日替わり）
  dailyTitle: '오늘의 스테이지',
  dailyLoading: '불러오는 중…',
  dailyOffline: '연결할 수 없어 오늘의 스테이지를 열 수 없습니다',
  dailyPlay: '플레이',
  dailyCleared: (time: string) => `통수 완료 ${time}`,
  archiveTitle: '지난 스테이지',
  upcomingTitle: '다가올 스테이지',
  archiveLocked: '최근 3일 치는 무료. 그보다 이전 스테이지는 엑스트라를 구매하면 모두 열립니다',
  language: '언어',
  languageAuto: '기기 설정에 맞춤',
  palette: '배색',
  worn: '사용 중',
  owned: '보유',
  buyDrops: '물방울 구매',
  restore: '구매 복원',
  writeReview: '이 앱을 평가하기',
  moreApps: '만든 사람의 다른 작품',
  restoreChecking: '확인하고 있습니다…',
  restoreDone: (n) => `${n}건을 복원했습니다`,
  restoreNone: '복원할 것이 없습니다',
  restoreFailed: '복원할 수 없었습니다',
  chooseStage: '스테이지 선택',
  resume: '계속하기',

  prizeLabel: '클리어 보상',
  awardLabel: '칭호',
  toExtra: '엑스트라로',
  toLoop2: '2회차로',
  toStart: '처음으로',
  allClearTitle: '완주',
  allClearBody: (n) => `${n}개의 수로 전부에 물이 통했다`,
  multiplyTimes: (mult) => `광고를 보고 ${mult}배`,
  noteRank: '칭호는 기록에 남아 스테이지 목록 위에 표시됩니다.',
  noteLoop2: '2회차가 열렸습니다. 수와 시간이 더 빡빡합니다.',
  notePartOne: '여기까지가 제1부. 물은 아직 오르지 않았다.',
  inviteTry: '엑스트라 1 체험하기',
  inviteOpen: '엑스트라 1집 20스테이지 열기',
  dateLine: (d) => `${d.getFullYear()}년 ${d.getMonth() + 1}월 ${d.getDate()}일`,

  completionTitle: '무궁을 건넌 자',
  rank: {
    none: '—',
    sovereign: '물을 다스리는 자',
    architect: '폭포의 설계자',
    mason: '석공',
    apprentice: '견습',
    wayfarer: '나그네',
  },

  skin: {
    hakushi: '백지',
    ai: '쪽빛',
    koke: '이끼',
    shu: '주홍',
    sumi: '먹',
  },

  product: {
    drops600: '물방울 600',
    drops1600: '물방울 1,600',
    drops5000: '물방울 5,000',
    noads: '광고 제거',
    extras: '엑스트라 1집 21스테이지(광고 없음)',
  },
};
